import consumer from "./consumer"

// ChatBadgeChannel - Real-time chat badge updates via ActionCable
//
// Purpose: Direct ActionCable channel for chat badge updates.
// This provides a reliable fallback to Turbo Streams custom action (update_badge)
// which can have timing/subscription issues with data-turbo-permanent elements.
//
// Flow:
//   Server broadcasts to "chat_badge_user_#{user.id}"
//   → ChatBadgeChannel receives { unread_count: N }
//   → Dispatches "badge:update" event → badge_sync_controller handles update
//
// Design: Reuses badge_sync_controller's updateBadge() via custom event
// to avoid duplicating badge update logic (SSOT principle).

let subscription = null

function connectChatBadgeChannel() {
  if (subscription) {
    console.debug("[ChatBadgeChannel] Already connected")
    return subscription
  }

  subscription = consumer.subscriptions.create("ChatBadgeChannel", {
    connected() {
      console.log("[ChatBadgeChannel] Connected to chat badge stream")
    },

    disconnected() {
      console.log("[ChatBadgeChannel] Disconnected from chat badge stream")
      subscription = null
    },

    received(data) {
      console.debug("[ChatBadgeChannel] Received:", data)

      if (data.unread_count !== undefined) {
        // Dispatch badge:update event - same event that Turbo Stream custom action uses
        // badge_sync_controller.js handles the actual DOM update (SSOT for badge logic)
        window.dispatchEvent(new CustomEvent("badge:update", {
          detail: { targetId: "chat_badge", count: data.unread_count },
          bubbles: false
        }))
      }
    }
  })

  return subscription
}

// Auto-connect on Turbo navigation
// Note: DOMContentLoaded is unnecessary - turbo:load fires on initial load too
document.addEventListener("turbo:load", () => {
  const userSignedIn = document.body.dataset.userSignedIn === "true"

  if (userSignedIn) {
    connectChatBadgeChannel()
  }
})

export { connectChatBadgeChannel }
